import edit from 'reducers/location/edit';
import list from 'reducers/location/list';
import { combineReducers } from 'redux-immutable';

export default combineReducers({ list, edit });
